import axios from "axios";

export async function getAllSamplesByKit({ commit }, kit) {
  try {
    const { data } = await axios.get(
      `samples/get-all-samples-from-kit/${kit.type}/${kit.code}`
    );
    return data.samples;
  } catch (e) {
    return 0;
  }
}

export async function getAllSamples({ commit }) {
  try {
    const { data } = await axios.get(`samples/get-all-samples-from-user`);
    return data.samples;
  } catch (e) {
    return 0;
  }
}

export async function getSamplesById({ commit }, areaId) {
  try {
    const response = await axios.get(`samples/get-samples-by-area/${areaId}`);
    return response.data;
  } catch (e) {
    return 0;
  }
}

export async function getSamplesFiltered({ commit }, payload) {
  try {
    const { data } = await axios.post("samples/get-samples-by-status", payload);
    return data;
  } catch (e) {
    return e;
  }
}

export async function getSampleById({ commit }, payload) {
  try {
    const { data } = await axios.get(`samples/${payload}`);
    return data;
  } catch (e) {
    return e;
  }
}

export async function fetchAllAreas({ commit }, id) {
  try {
    const { data } = await axios.post(`soilAreas/get-areas-by-client`, {
      organizationId: id,
    });
    commit("SET_AREAS", data.soilAreas);
  } catch (e) {
  } finally {
  }
}

export async function saveNotGeoSample({ commit }, payload) {
  try {
    const { data } = await axios.post(`samples/createSimpleSample`, payload);
    return data;
  } catch (e) {
    return e;
  }
}

export async function saveSampleNotAdvisor({ commit }, payload) {
  try {
    const { data } = await axios.post(`samples/createAdvisorSample/v2`, payload);
    return data;
  } catch (e) {
    return e;
  }
}
export async function checkPermissionSampleNotAdvisor({ commit }) {
  try {
    const { data } = await axios.post(
      `samples/check-sampler-permission-advisor`
    );
    return data;
  } catch (e) {
    return e;
  }
}

export async function getAnalysisByArea({ commit }, payload) {
  try {
    const { data } = await axios.get(`samples/get-samples-analized/${payload}`);
    return data;
  } catch (e) {
    return e;
  }
}

export async function getImg({ commit }, payload) {
  try {
    const { data } = await axios.post(`subSample/get-img`, payload);
    return data;
  } catch (e) {
    return e;
  }
}

export async function getAnalysis({ commit }, payload) {
  try {
    const { data } = await axios.post(`samples/get-analysis`, payload);
    return data;
  } catch (e) {
    return e;
  }
}

export async function uploadImage({ state }, image) {
  try {
    const { data } = await axios.post("/samples/upload-image", image);
    if (data.error) throw data;
    return data;
  } catch (error) {
    return error;
  }
}

export async function requestSampleGuide({ commit }, payload) {
  try {
    const { data } = await axios.post(`seller/new-shipment`, payload);
    return data;
  } catch (e) {
    return e;
  }
}



export async function updateSampleInfo({ commit }, payload) {
  try {
    const { data } = await axios.post(`samples/update-sample-info`, payload);
    return data;
  } catch (e) {
    throw Error(e.message)
  }
}




export async function setSamplePackage({ commit }, payload) {
  try {
    const { data } = await axios.post(`samples/set-package`, payload);
    return data;
  } catch (e) {
    throw Error(e.message)
  }
}
